__turbopack_context__.v({
  "invisibleInput": "datepicker-module-scss-module__McmPiq__invisibleInput",
  "popper": "datepicker-module-scss-module__McmPiq__popper",
  "time": "datepicker-module-scss-module__McmPiq__time",
  "wrapper": "datepicker-module-scss-module__McmPiq__wrapper",
});
